import { useContext, useEffect, useState } from "react";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import PoFormContext from "../../../../contexts/poFormContext";
import { createConfigValidation } from "../../../../helpers/validation/validation";

const ObservationConclusions = () => {
    const { poForm, setPoForm } = useContext(PoFormContext);
    const [errorTipText, setErrorTipText] = useState("");
    const [reload, setReload] = useState(false);

    // Validation
    useEffect(() => {
        if (poForm.config?.check && !poForm.config.isValid) {
            var errorMsg = poForm.config?.ValidationError!["wnioski"]
            if (errorMsg != null) {
                setErrorTipText(errorMsg);
                setReload(!reload);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poForm.config?.check])
    
    const onChangeInput = (event: string) => {
        var form: any = Object.assign({}, poForm);
        if (form !== null && form.protocolAttributes) form.protocolAttributes.wnioski = event;
        setPoForm(form);
    }

    // Observation conclusions
    var textAreaPropsObservationConclusions: TextAreaFieldProps = {
        labelName: 'Wnioski z obserwacji',
        textAreaPlaceholder: poForm.protocolAttributes?.wnioski == null || poForm.protocolAttributes?.wnioski === '' ? 'Dodaj opis' : '',
        value: poForm.protocolAttributes?.wnioski,
        textareaSharedProps: {
            className: poForm.protocolAttributes?.wnioski == null || poForm.protocolAttributes?.wnioski === '' ? 'body-txt-medium-sec-gray' : 'largeFormTextarea body-txt-large',
            style: {
                minHeight: '190px'
            }
        },
        configValidation: createConfigValidation("wnioski", true),
        disabled: false,
        setValue: onChangeInput,
        pristine: true,
        validationError: poForm.config?.isValid !== undefined ? !poForm.config?.isValid : false,
        tipText: errorTipText,
        reload: reload,
        dynamicResize: true
    }

    return (
        <div>
            <h2>2. Wnioski z obserwacji</h2>
            <TextAreaField {...textAreaPropsObservationConclusions}/>
        </div>
    )

}

export default ObservationConclusions;